module.exports = __webpack_public_path__ + "img/hearts-end.a75bc65a.svg";